import {
  styled,
  List,
  ListItem,
  ListItemButton,
  listItemButtonClasses,
  ListItemIcon,
  ListItemText,
  svgIconClasses,
} from '@mui/material';
import { alpha } from '@mui/material/styles';

import AccessFeature from '../AccessFeature';

import { NavigationListItemButtonActionProps } from './types';

const classes = {
  listItemIcon: 'NavigationListItemIcon-root',
  listItemText: 'NavigationListItemText-root',
};

export const NavigationListContainer = styled(List)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
  padding: 6,
  border: `1px solid ${theme.palette.divider}`,
}));

export const NavigationListItemContainer = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'hasChildren',
})<{ hasChildren?: boolean }>(({ hasChildren }) => ({
  padding: 0,

  ...(hasChildren && {
    flexDirection: 'column',
    alignItems: 'stretch',
  }),

  '&:not(:last-child)': {
    paddingBottom: 1,
  },
}));

export const NavigationListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<NavigationListItemButtonActionProps>(({ theme, isActive }) => ({
  padding: theme.spacing(1, 2),
  borderRadius: 8,

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },

  [`&.${listItemButtonClasses.disabled}`]: {
    opacity: 1,

    [`& .${classes.listItemIcon}`]: {
      opacity: theme.palette.action.disabledOpacity,
    },

    [`& .${classes.listItemText}`]: {
      opacity: theme.palette.action.disabledOpacity,
    },
  },

  ...(isActive && {
    backgroundColor: alpha(
      theme.palette.primary.main,
      theme.palette.action.selectedOpacity,
    ),

    '&:hover': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
      ),
    },

    [`& .${classes.listItemIcon}`]: {
      color: theme.palette.primary.main,
    },

    [`& .${classes.listItemText}`]: {
      color: theme.palette.primary.main,
    },
  }),
}));

export const NavigationListItemButtonAccessFeature = styled(
  AccessFeature.ListItemButton,
  {
    shouldForwardProp: (prop) => prop !== 'isActive',
  },
)<NavigationListItemButtonActionProps>(({ theme, isActive }) => ({
  padding: theme.spacing(1, 2),
  borderRadius: 8,

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },

  [`&.${listItemButtonClasses.disabled}`]: {
    opacity: 1,

    [`& .${classes.listItemIcon}`]: {
      opacity: theme.palette.action.disabledOpacity,
    },

    [`& .${classes.listItemText}`]: {
      opacity: theme.palette.action.disabledOpacity,
    },
  },

  ...(isActive && {
    backgroundColor: alpha(
      theme.palette.primary.main,
      theme.palette.action.selectedOpacity,
    ),

    '&:hover': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
      ),
    },

    [`& .${classes.listItemIcon}`]: {
      color: theme.palette.primary.main,
    },

    [`& .${classes.listItemText}`]: {
      color: theme.palette.primary.main,
    },
  }),
}));

export const NavigationListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 16,
  marginRight: theme.spacing(1),

  '& svg': {
    fontSize: 16,
    width: '1em',
    height: '1em',

    [`&.${svgIconClasses.root}`]: {
      fontSize: 18,
    },
  },
}));
NavigationListItemIcon.defaultProps = {
  className: classes.listItemIcon,
};

export const NavigationListItemText = styled(ListItemText)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.secondary.main,
  margin: 0,
}));
NavigationListItemText.defaultProps = {
  className: classes.listItemText,
};

export const NavigationSubList = styled(List)(({ theme }) => ({
  padding: 0,
  paddingLeft: theme.spacing(1.5),
  marginLeft: theme.spacing(3),
  marginBottom: theme.spacing(0.5),
  marginTop: theme.spacing(0.5),
  borderLeft: `1px solid ${theme.palette.divider}`,
}));
